module.exports = __webpack_public_path__ + "static/media/cardio.b5a8d40d.svg";